import { Stack, Typography } from '@mui/material';
import type { FC } from 'react';

interface ErrorProps {
  error: {
    response?: {
      data?: {
        message?: string;
        messages?: string[];
      };
    };
    message?: string;
  };
}

const defaultErrorText =
  'An unexpected error has occurred. Please try again later or contact your support team.';

const Error: FC<ErrorProps> = ({ error }) => {
  const errorText =
    error?.response?.data?.message ||
    error?.response?.data?.messages?.[0] ||
    error?.message ||
    defaultErrorText;

  return (
    <Stack alignItems="center">
      <Typography
        sx={{
          maxWidth: '400px',
          textAlign: 'center',
          p: 2,
          color: (theme) => theme.palette.customColors.errorRed,
        }}
      >
        {errorText}
      </Typography>
    </Stack>
  );
};

export default Error;
